$(document).ready(function () {
  function handleFooterAccordionClick() {
    var windowWidth = $(window).width();

    if (windowWidth < 799) {
      var $this = $(this);
      $this.toggleClass("active");

      var $currentBlock = $this.closest(".footer__block");

      if ($currentBlock.hasClass("four")) {
        $currentBlock.find(".footer__menu ul, .accordion-newsletter").slideToggle();
      } else {
        $this.next().slideToggle();
      }
    }
  }

  $(".footer__content .footer__block .footer__heading").on("click", handleFooterAccordionClick);
});

// Custom Mega Menu Script Start
$(document).ready(function () {
  if ($(window).width() >= 799) {
    $('body').on('mouseenter', '.parent-menu-list li', function () {
      var target = $(this).data('mega-menu');
    
      if (typeof target !== 'undefined') {
        $('.parent-menu-list li, .magic-wrapper').removeClass('active');
        $(this).addClass('active');
        $('.magic-wrapper[data-mega-menu="' + target + '"]').addClass('active');
      }
    });
    $('body').on('mouseenter', '.magic-wrapper.active .child-menu-list ul li', function () {
      var heading = $(this).data('heading');
      var $activeWrapper = $('.magic-wrapper.active');
    
      $activeWrapper.find('.child-menu-list ul li, .sub-child-menu-list ul li, .sub-child-menu-list ul').removeClass('active');
      $(this).addClass('active');
    
      var $subMenu = $activeWrapper.find('.sub-child-menu-list ul[data-parent-name="' + heading + '"]');
    
      if ($subMenu.length) {
        $activeWrapper.find('.sub-child-menu-list').show();
        $subMenu.addClass('active');
    
        var $firstSubItem = $subMenu.find('li').first().addClass('active');
        var subHeading = $firstSubItem.data('heading');
        console.log('subHeading:', subHeading);
        
        setTimeout(function () {
          $activeWrapper.find('.collection-products-block').removeClass('active');
          $activeWrapper.find('.collection-products-block[data-collection="' + subHeading + '"]').addClass('active');
        }, 10);
      } else {
        $activeWrapper.find('.sub-child-menu-list').hide();
        
        $activeWrapper.find('.collection-products-block').removeClass('active');
        $activeWrapper.find('.collection-products-block[data-collection="' + heading + '"]').addClass('active');
      }
    });
    $('body').on('mouseenter', '.magic-wrapper.active .sub-child-menu-list ul.active li', function () {
      var heading = $(this).data('heading');
      var $activeWrapper = $('.magic-wrapper.active');
    
      $activeWrapper.find('.sub-child-menu-list ul li, .collection-products-block').removeClass('active');
    
      $(this).addClass('active');
    
      $activeWrapper.find('.collection-products-block[data-collection="' + heading + '"]').addClass('active');
    });
    $('body').on('mouseenter', '.mega-menu__section:visible .subpage-wrapper.active .mega-menu__linklist li.nav-item', function () {
      var $subWrapper = $(this).closest('.subpage-wrapper');
      var collectionName = $(this).data('collection');
    
      $subWrapper.find('.mega-menu__linklist li.nav-item').removeClass('active');
      $subWrapper.find('.collection-products-block').removeClass('active');
    
      $(this).addClass('active');
    
      $subWrapper.find('.collection-products-block').each(function () {
        if ($(this).data('collection') === collectionName) {
          $(this).addClass('active');
        }
      });
    });
  }
});

$(document).ready(function () {
  // ===== CHQ MOBILE NAV FIXES (2026-05-26) =====
  // FIX 1: scoped, structural .back-btn handler — replaces the broken
  //        hardcoded-ID handler that lived at old lines 249-267.
  //        Walks .back-btn → ancestor .mobile-menu__first-level → that
  //        container's own .submenu__input checkbox. No ID guessing.
  // FIX 2: mobile drill-down init wrapped in idempotent function that
  //        re-runs on resize/orientationchange (debounced).
  // Backup: _backups/menu-fix-20260526T210126Z/
  // =============================================
  // FIX 4 (2026-05-26): tier-aware back button.
  //   - If user is drilled in (viewStack > 0): pop one level (parent ← child ← sub-child)
  //   - If user is at root of the mega: close the mega menu and reset state
  //   The actual handler is set up INSIDE chqInitMobileMegaNav() so it has
  //   direct access to viewStack + the show/hide helpers. See window.__chqBackBtnClick.

  function chqInitMobileMegaNav() {
    // CHQ 2026-09-23j — CoS audit minimal fix (RC1–RC5).
    // Always cleanup (handles desktop→mobile and mobile→desktop transitions).
    $('body').off('.mmParent .mmChild .mmSub .mmNav .chqTouchGuard .chqNavLockArm');
    $('body').off('change.chqMegaOpenReset');
    $('body').off('click.chqTileGuard');
    $(document).off('click.chqMobBack');
    $('#mmBack').remove();
    if ($(window).width() > 798) return;

    const $back = $('<button id="mmBack" type="button" aria-label="Back"><svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="arrow left"> <path id="Vector 190 (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M0.46967 5.53033C0.176777 5.23744 0.176777 4.76256 0.46967 4.46967L4.46967 0.46967C4.76256 0.176777 5.23744 0.176777 5.53033 0.46967C5.82322 0.762563 5.82322 1.23744 5.53033 1.53033L2.81066 4.25L13 4.25C13.4142 4.25 13.75 4.58579 13.75 5C13.75 5.41421 13.4142 5.75 13 5.75L2.81066 5.75L5.53033 8.46967C5.82322 8.76256 5.82322 9.23744 5.53033 9.53033C5.23744 9.82322 4.76256 9.82322 4.46967 9.53033L0.46967 5.53033Z" fill="#0A100D"></path> </g> </svg> Back</button>').appendTo('.mobile-top--wrapper');

    const $mobileMegas = () => $('#mobile-header .mobile-menu .mega-menu');

    const resetAllActives = ($scope) => {
      const $root = ($scope && $scope.length) ? $scope : $mobileMegas();
      $root.find([
        '.parent-menu-list li',
        '.magic-wrapper',
        '.child-menu-list ul li',
        '.sub-child-menu-list ul',
        '.sub-child-menu-list ul li',
        '.collection-products-block',
        '.subpage-wrapper',
        '.mega-menu__linklist li.nav-item'
      ].join(', ')).removeClass('active');
    };

    const showEl = ($el) => $el.removeClass('mm-hidden').show();
    const hideEl = ($el) => $el.addClass('mm-hidden').hide();

    const setActiveProducts = ($scope, key) => {
      $scope.find('.collection-products-block').removeClass('active');
      $scope.find(`.collection-products-block[data-collection="${key}"]`).addClass('active');
    };

    // Scoped to mobile mega clone(s) — never toggle desktop mega twins (RC5).
    const showParentScreen = ($mega) => {
      const $scope = ($mega && $mega.length) ? $mega : $mobileMegas();
      showEl($scope.find('.parent-menu-list'));
      hideEl($scope.find('.magic-wrapper'));
      $scope.find('.magic-wrapper').each(function () {
        const $w = $(this);
        $w.find('.child-menu-list ul li, .sub-child-menu-list ul, .sub-child-menu-list ul li, .collection-products-block').removeClass('active');
        showEl($w.find('.child-menu-list'));
        hideEl($w.find('.sub-child-menu-list').removeClass('is-sub-open'));
      });
    };

    const showChildScreen = ($wrapper) => {
      const $mega = $wrapper.closest('.mega-menu');
      hideEl($mega.find('.parent-menu-list'));
      showEl($wrapper);
      showEl($wrapper.find('.child-menu-list'));
      hideEl($wrapper.find('.sub-child-menu-list'));
      $mega.find('.sub-child-menu-list').removeClass('is-sub-open');
    };

    const showSubChildScreen = ($wrapper, $subMenu) => {
      hideEl($wrapper.find('.child-menu-list'));
      showEl($wrapper.find('.sub-child-menu-list'));
      $wrapper.find('.sub-child-menu-list ul').removeClass('active');
      $wrapper.find('.sub-child-menu-list').removeClass('is-sub-open');
      $subMenu.addClass('active');
      $subMenu.parent().addClass('is-sub-open');
    };

    const viewStack = [];
    const updateBackVisibility = () => {
      if (viewStack.length > 0) $back.show(); else $back.hide();
    };

    // CHQ 2026-09-23k2: ignore Back / drill / tile clicks after touch-scroll (≥12px).
    // Simpler than 23k: no 1s suppress window, no capture-phase blocker, no pointer-events:none on rows/tiles.
    // Flag resets only on the next touchstart (intentional tap). Delayed iOS ghost clicks after a
    // moved touchend have no new touchstart, so they still see chqTouchMoved=true and are cancelled.
    // CSS .is-chq-touch-scrolling still clears after 450ms (Back-only pointer-events rule from 23j).
    var chqTouchMoved = false;
    var chqTX = 0, chqTY = 0;
    var CHQ_MOVE_PX = 12;
    $('body').on('touchstart.chqTouchGuard', '#mobile-header .mobile-menu', function (e) {
      var t = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
      if (!t) return;
      chqTX = t.clientX;
      chqTY = t.clientY;
      chqTouchMoved = false;
      $('#mobile-header .mobile-menu').removeClass('is-chq-touch-scrolling');
    });
    $('body').on('touchmove.chqTouchGuard', '#mobile-header .mobile-menu', function (e) {
      var t = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
      if (!t) return;
      if (Math.abs(t.clientX - chqTX) >= CHQ_MOVE_PX || Math.abs(t.clientY - chqTY) >= CHQ_MOVE_PX) {
        chqTouchMoved = true;
        $('#mobile-header .mobile-menu').addClass('is-chq-touch-scrolling');
      }
    });
    $('body').on('touchend.chqTouchGuard touchcancel.chqTouchGuard', '#mobile-header .mobile-menu', function () {
      var $m = $('#mobile-header .mobile-menu');
      // Do NOT clear chqTouchMoved here — only next touchstart clears it (blocks delayed ghost clicks).
      setTimeout(function () {
        $m.removeClass('is-chq-touch-scrolling');
      }, 450);
    });
    function chqBlockIfScrolled(e) {
      if (!chqTouchMoved) return false;
      e.preventDefault();
      e.stopImmediatePropagation();
      return true;
    }

    // CHQ 2026-09-23j: arm nav-lock on touchstart BEFORE DOM mutate (RC1).
    var chqNavLockUntil = 0;
    function chqArmNavLock(ms) {
      var dur = (typeof ms === 'number') ? ms : 700;
      chqNavLockUntil = Date.now() + dur;
      var $m = $('#mobile-header .mobile-menu');
      $m.addClass('is-chq-nav-lock');
      setTimeout(function () {
        if (Date.now() >= chqNavLockUntil) $m.removeClass('is-chq-nav-lock');
      }, dur + 30);
    }
    function chqNavLocked() {
      return Date.now() < chqNavLockUntil;
    }
    $('body').on(
      'touchstart.chqNavLockArm',
      '#mobile-header .mobile-menu .parent-menu-list li > a, #mobile-header .mobile-menu .magic-wrapper.active .child-menu-list ul li > a',
      function () {
        chqArmNavLock(700);
      }
    );

    $('body').on('click.chqTileGuard', '#mobile-header .mobile-menu a.collection-details__tile', function (e) {
      if (chqBlockIfScrolled(e)) return false;
    });

    $back.on('click', function (e) {
      if (chqNavLocked() || chqBlockIfScrolled(e)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      const state = viewStack.pop();
      if (state && typeof state.restore === 'function') state.restore();
      updateBackVisibility();
    });

    window.__chqResetMegaNavState = function ($scope) {
      var $root = ($scope && $scope.length) ? $scope : $(document);
      $root.find([
        '.parent-menu-list li',
        '.magic-wrapper',
        '.child-menu-list ul li',
        '.sub-child-menu-list ul',
        '.sub-child-menu-list ul li',
        '.collection-products-block',
        '.subpage-wrapper',
        '.mega-menu__linklist li.nav-item'
      ].join(', ')).removeClass('active');
      $root.find('.parent-menu-list').removeClass('mm-hidden').css('display', '');
      $root.find('.magic-wrapper').addClass('mm-hidden').css('display', 'none');
      $root.find('.magic-wrapper').each(function () {
        var $w = $(this);
        $w.find('.child-menu-list').removeClass('mm-hidden').css('display', '');
        $w.find('.sub-child-menu-list').addClass('mm-hidden').css('display', 'none').removeClass('is-sub-open');
      });
      viewStack.length = 0;
      updateBackVisibility();
    };

    $(document).on('click.chqMobBack', '.mobile-menu .back-btn', function (e) {
      if (chqNavLocked() || chqBlockIfScrolled(e)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      e.preventDefault();
      if (viewStack.length > 0) {
        var state = viewStack.pop();
        if (state && typeof state.restore === 'function') state.restore();
        updateBackVisibility();
      } else {
        var $firstLevel = $(this).closest('.mobile-menu__first-level');
        window.__chqResetMegaNavState($firstLevel);
        $firstLevel.children('.submenu__input').prop('checked', false).trigger('change');
      }
    });

    resetAllActives();
    showParentScreen();
    updateBackVisibility();

    // RC4: off before on so resize/re-init does not stack reset handlers.
    $('body').off('change.chqMegaOpenReset').on('change.chqMegaOpenReset', '.mobile-menu .submenu__input', function () {
      if (!this.checked) return;
      var $fl = $(this).closest('.mobile-menu__first-level');
      if (!$fl.find('.mobile-menu__submenu.has-mega-menu').length) return;
      if (typeof window.__chqResetMegaNavState === 'function') {
        window.__chqResetMegaNavState($fl);
      } else {
        resetAllActives($fl);
        showParentScreen($fl.find('.mega-menu'));
        updateBackVisibility();
      }
    });

    $('body').on('click.mmParent', '#mobile-header .mobile-menu .parent-menu-list li > a', function (e) {
      if (chqBlockIfScrolled(e)) return false;
      e.preventDefault();

      const $mega = $(this).closest('.mobile-menu .mega-menu');
      const $li = $(this).closest('li');
      const target = $li.data('mega-menu');
      if (typeof target === 'undefined') return;

      const $wrapper = $mega.find(`.magic-wrapper[data-mega-menu="${target}"]`);
      if (!$wrapper.length) return;

      viewStack.push({
        restore: () => {
          resetAllActives($mega);
          showParentScreen($mega);
        }
      });

      $li.closest('.parent-menu-list').find('li').removeClass('active');
      $mega.find('.magic-wrapper').removeClass('active');
      $li.addClass('active');
      $wrapper.addClass('active');

      showChildScreen($wrapper);
      updateBackVisibility();
      chqArmNavLock(700);
    });

    $('body').on('click.mmChild', '#mobile-header .mobile-menu .magic-wrapper.active .child-menu-list ul li > a', function (e) {
      if (chqBlockIfScrolled(e)) return false;
      e.preventDefault();

      const $mega = $(this).closest('.mobile-menu .mega-menu');
      const $item = $(this).closest('li');
      const heading = $item.data('heading');
      const $wrapper = $mega.find('.magic-wrapper.active');
      if (!$wrapper.length) return;

      viewStack.push({
        restore: () => {
          $wrapper.find('.sub-child-menu-list ul, .sub-child-menu-list ul li, .collection-products-block').removeClass('active');
          showChildScreen($wrapper);
        }
      });

      $wrapper.find('.child-menu-list ul li, .sub-child-menu-list ul, .sub-child-menu-list ul li').removeClass('active');
      $item.addClass('active');

      const $subMenu = $wrapper.find(`.sub-child-menu-list ul[data-parent-name="${heading}"]`);
      if ($subMenu.length) {
        showSubChildScreen($wrapper, $subMenu);
        const $first = $subMenu.find('li').first().addClass('active');
        const subHeading = $first.data('heading');
        setActiveProducts($wrapper, subHeading);
      } else {
        setActiveProducts($wrapper, heading);
        hideEl($wrapper.find('.child-menu-list'));
      }

      updateBackVisibility();
      chqArmNavLock(700);
    });

    $('body').on('click.mmSub', '#mobile-header .mobile-menu .magic-wrapper.active .sub-child-menu-list ul.active li > a', function (e) {
      if (chqBlockIfScrolled(e)) return false;
      // Real collection tiles navigate; only intercept non-tile sub links.
      if ($(this).is('a.collection-details__tile') || $(this).closest('a.collection-details__tile').length) {
        return;
      }
      e.preventDefault();
      const $mega = $(this).closest('.mobile-menu .mega-menu');
      const $li = $(this).closest('li');
      const heading = $li.data('heading');
      const $wrapper = $mega.find('.magic-wrapper.active');
      $wrapper.find('.sub-child-menu-list ul li').removeClass('active');
      $li.addClass('active');
      setActiveProducts($wrapper, heading);
    });

    $('body').on('click.mmNav', '#mobile-header .mobile-menu .mega-menu__section:visible .subpage-wrapper.active .mega-menu__linklist li.nav-item > a', function (e) {
      if (chqBlockIfScrolled(e)) return false;
      e.preventDefault();
      const $li = $(this).closest('li.nav-item');
      const $subWrapper = $li.closest('.subpage-wrapper');
      const collectionName = $li.data('collection');

      viewStack.push({
        restore: () => {
          $subWrapper.find('.mega-menu__linklist li.nav-item, .collection-products-block').removeClass('active');
        }
      });

      $subWrapper.find('.mega-menu__linklist li.nav-item').removeClass('active');
      $subWrapper.find('.collection-products-block').removeClass('active');

      $li.addClass('active');
      $subWrapper.find(`.collection-products-block[data-collection="${collectionName}"]`).addClass('active');

      updateBackVisibility();
      chqArmNavLock(700);
    });
  } // end chqInitMobileMegaNav

  chqInitMobileMegaNav();

  let chqMobResizeTimer;
  $(window).off('resize.chqMobNav orientationchange.chqMobNav').on('resize.chqMobNav orientationchange.chqMobNav', function () {
    clearTimeout(chqMobResizeTimer);
    chqMobResizeTimer = setTimeout(function () {
      // RC4: do not wipe viewStack mid-drill on soft mobile resize while drawer open.
      if ($('body').hasClass('mobile-menu--opened') && $(window).width() <= 798) {
        return;
      }
      chqInitMobileMegaNav();
    }, 250);
  });

  $('.mobile-menu__toggle-button').off('click.chqMmBackHide').on('click.chqMmBackHide', function() {
    $('#mmBack').hide();
  });
});

// Custom Mega Menu Script End

/* ============================================================
   FIX: Resources sub-menu accordion
      Closes sibling sub-menus when a new one is opened.
         Scoped ONLY to .navbar-dropdown.is-vertical .has-submenu toggles.
            Does NOT affect collection page filters or any other checkboxes.
               TO REVERT: Delete from this comment down to and including END FIX below.
                  ============================================================ */
                  document.addEventListener('DOMContentLoaded', function () {
                      var navbarDropdowns = document.querySelectorAll('.navbar-dropdown.is-vertical');
                        navbarDropdowns.forEach(function (dropdown) {
                              var toggles = dropdown.querySelectorAll('.has-submenu .close-dropdown');
                                  toggles.forEach(function (toggle) {
                                          toggle.addEventListener('click', function () {
                                                    var parentHasSubmenu = toggle.closest('.has-submenu');
                                                            dropdown.querySelectorAll('.has-submenu').forEach(function (sibling) {
                                                                        if (sibling !== parentHasSubmenu) {
                                                                                      var siblingCheckbox = sibling.querySelector('input[type="checkbox"].visuallyhidden');
                                                                                                  if (siblingCheckbox && siblingCheckbox.checked) {
                                                                                                                  siblingCheckbox.checked = false;
                                                                                                  }
                                                                        }
                                                            })
                                          })
                                  })
                        })
                  })
/* ========================================================
    END FIX: Resources sub-menu accordion
        ======================================================== */                  